import * as React from "react";
import LinearProgress from "@mui/material/LinearProgress";

declare const window: any;

export default function CardV1({
  intro,
  progress,
  theme,
  setIntroView,
  isLoaded,
  isPortrait,
  counter,
}: any) {
  const [timeLoad, setTimeLoad] = React.useState(0);
  //console.log(intro);

  React.useEffect(() => {
    // Aquí puedes definir el color de fondo de la clase intro-cardv1-load-bar
    const loadBar: any = document.querySelector(".intro-cardv1-load-bar");
    if (loadBar) {
      loadBar.style.backgroundColor = "#fff";
    }

    // Aquí puedes definir el color de fondo del span dentro del componente
    const spanElement: any = document.querySelector(
      ".intro-cardv1-load-bar span"
    );
    if (spanElement) {
      spanElement.style.backgroundColor = intro?.colors?.main_buttons; // Puedes ajustar el color que desees aquí
    }
  }, [intro?.colors?.main_buttons]);

  const handleIngreso = () => {
    const containerWrapper: any = document.querySelector(
      ".intro-cardv1-container-wrapper"
    );
    //containerWrapper.classList.remove("ocultar-intro-container");
    containerWrapper.classList.add("ocultar-intro-container");
    setTimeout(() => {
      setIntroView(false);
      containerWrapper.classList.add("ocultar");
    }, 501);
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  return (
    <>
      {intro &&
        intro.type_product &&
        intro.type_product.toLowerCase() === "3d" && (
          <div className={`intro-cardv1-container-blur ${theme}`} />
        )}
      <div
        className={`intro-cardv1-container-wrapper ${
          Object.keys(intro).length > 0 ? "active" : ""
        }`}
      >
        <div className={`intro-cardv1-container ${theme}`}>
          <div
            className="intro-cardv1-logos"
            style={
              intro?.logos_multiples?.length > 0
                ? {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }
                : {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                  }
            }
          >
            {/* Logo del proyecto */}
            {intro?.active_project_logo ? (
              <img
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://d1bsymnertnea6.cloudfront.net/"
                }galleries/${window?.builder_id}/${
                  window?.project_id
                }/logo.svg`}
                alt="Logo proyecto"
                style={
                  intro?.logos_multiples?.length > 0
                    ? { marginBottom: "0.75rem" }
                    : { height: "100px" }
                }
              />
            ) : null}

            {intro?.logos_multiples?.length === 0 ? (
              // Caso SIN logos adicionales → proyecto y constructora al mismo nivel
              intro?.active_builder_logo ? (
                <img
                  src={`${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net/"
                  }galleries/${window?.builder_id}/logo.svg`}
                  alt="Logo constructora"
                  style={{ height: "100px" }}
                />
              ) : null
            ) : (
              // Caso CON 1 o más logos adicionales
              <div
                className={`intro-cardv1-logos-multiples count-${
                  intro?.logos_multiples?.length +
                  (intro?.active_builder_logo ? 1 : 0)
                }`}
                style={{
                  display: "flex",
                }}
              >
                {/* Logo constructora */}
                {intro?.active_builder_logo ? (
                  <img
                    src={`${
                      window.hybrid
                        ? "./"
                        : "https://d1bsymnertnea6.cloudfront.net/"
                    }galleries/${window?.builder_id}/logo.svg`}
                    alt="Logo constructora"
                    //style={{ height: "100px" }}
                  />
                ) : null}

                {/* Logos adicionales */}
                {intro?.logos_multiples
                  ?.slice() // copiamos el array para no mutar el original
                  .sort((a: any, b: any) => a.indice - b.indice) // orden ascendente por indice
                  .map((item: any, i: number) => (
                    <img
                      key={i}
                      src={`${
                        window.hybrid
                          ? "./"
                          : "https://d1bsymnertnea6.cloudfront.net/"
                      }${item.link}`}
                      alt={`Logo adicional ${i + 1}`}
                      // style={{ height: "100px" }}
                    />
                  ))}
              </div>
            )}
          </div>

          <div className="intro-cardv1-legal-text">{intro?.texto_legal}</div>
          {progress >= 100 || (progress >= 80 && counter >= 180) ? (
            <div
              className="intro-cardv1-ingresar"
              style={{
                backgroundColor: intro?.colors?.main_buttons,
                color: intro?.colors?.secondary_text,
                marginTop: "40px",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = darkenColor(
                  intro?.colors?.main_buttons,
                  -0.2
                );
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor =
                  intro?.colors?.main_buttons;
              }}
              onClick={() => handleIngreso()}
              data-type={"INGRESO"}
              data-value={"INGRESO"}
            >
              Aceptar
            </div>
          ) : (
            <div className="intro-cardv1-load">
              <span>Cargando...</span>
              <LinearProgress
                variant="determinate"
                className="intro-cardv1-load-bar"
                value={progress}
              />
              <p>{progress}%</p>
            </div>
          )}
          <div className="intro-cardv1-poweredBy">
            Powered by ® Umbra Group - 2025
          </div>
        </div>
      </div>
    </>
  );
}
